<template>
	<div>
		<!-- 交易记录 -->
		<el-dialog width="494px" :visible.sync="show" :append-to-body="true" @close="close" @open="open()" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="trade_dialog_box">
				<div class="trade_dialog_top_box">
					<div class="trade_dialog_top">
						<div class="trade_dialog_top_title">
							Transactions
						</div>
						<img @click="clickClose()" class="trade_dialog_top_close_icon"
							src="../../../assets/icons/close_icon2.png" alt="" />
					</div>
					<div class="flex_ac_sb">
						<div class="trade_dialog_menu">
							<el-select v-model="select1" @change="changeSelect($event,1)" slot="prepend" placeholder="">
								<el-option v-for="item in selectList1" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="trade_dialog_menu mar_l10">
							<el-select v-model="select2" @change="changeSelect($event,2)" slot="prepend" placeholder="">
								<el-option v-for="item in selectList2" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="trade_dialog_menu mar_l10">
							<el-select v-model="select3" @change="changeSelect($event,3)" slot="prepend" placeholder="">
								<el-option v-for="item in selectList3" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="trade_dialog_content ">
					<div class="trade_dialog_list" v-if="transactionsList.length>0">
						<div class="trade_dialog_list_item" v-for="(item,index) in transactionsList"
							:key="item.detailId">
							<img v-if="select2!=2" class="trade_dialog_list_item_avatar" :src="item.bankImage" alt="" />
							<img v-else class="trade_dialog_list_item_avatar2" src="../../../assets/icons/n_icon2.png" alt="" />
							<div class="trade_dialog_list_item_info">
								<div v-if="select2!=2" class="trade_dialog_list_item_name">
									{{item.bankName}}
								</div>
								<div v-else class="trade_dialog_list_item_name">
									{{ typeMap[item.type] }}
								</div>
								<!-- 0 周奖励
								1月奖励
								2充值
								3提现 -->
								<div class="trade_dialog_list_item_time">
									{{convertUTCTime(item.createTime)}}
								</div>
							</div>
							<div class="trade_dialog_list_item_right">
								<div class="trade_dialog_list_item_right_title">
									₦{{item.balance?item.balance:0}}
								</div>
								<div v-if="item.status==1" class="trade_dialog_list_item_right_tag">
									Successful
								</div>
								<div v-else-if="item.status==2" class="trade_dialog_list_item_right_tag trade_tag2">
									Failed
								</div>
								<div v-else class="trade_dialog_list_item_right_tag trade_tag3">
									Pending
								</div>
							</div>
						</div>
					</div>
					<div v-else class="trade_dialog_list_bet_no">
						<img class="trade_dialog_list_bet_no_icon" src="../../../assets/icons/bet_no.png" alt="" />
					</div>
				</div>

				<div v-if="transactionsList.length>0" class="flex_as_c">
					<el-pagination background layout="prev, pager, next" :page-size="params.pageSize" :total="total"
						@current-change="changePageNum">
					</el-pagination>
				</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import moment from'moment-timezone';
	import { mapState } from 'vuex';


	export default {
		name: 'referralDialog',
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				total: 0,
				transactionsList: [], //交易记录列表
				typeMap: {
					0: "Weekly Reward",
					1: "Monthly Reward",
					2: "Recharge",
					3: "Withdrawal",
					4: "Sign-in Reward",
					5: "Spin and Win",
					6: "Order",
					7: "Order Income",
					8: "Invitation Reward",
					9: "Investment Order Income",
					10: "Gift Money to Real Money Conversion",
					21: "Personal Recharge Reward",
					22: "Upline Recharge Commission",
					23: "Back-end Recharge",
					24: "Invitation Recharge Gift Money Reward",
					77: "Order Rollback"
				},
				time: null, //时间筛选
				select1: '', //类别筛选day 查询日期0=今天，1=昨天，3=3天，7=7天，15=15天，30=30天
				select2: 0, //类别筛选type 查询类型（0=充值，1=提现，2=礼物）
				select3: '', //类别筛选status  状态(0=处理中，1=成功，2=失败)
				params: {
					pageSize: 10,
					pageNum: 1,
				},
				selectList1: [{
						label: 'All Time',
						value: '',
					}, {
						label: 'Today',
						value: 0,
					},
					{
						label: 'Yesterday',
						value: 1,
					},
					{
						label: 'Last 3 days',
						value: 3,
					},
					{
						label: 'Last 7 days',
						value: 7,
					},
					{
						label: 'Last 15 days',
						value: 15,
					},
					{
						label: 'Last 30 days',
						value: 30,
					},
				],
				selectList2: [{
						label: 'Deposit',
						value: 0,
					},
					{
						label: 'Withdraw',
						value: 1,
					},
					{
						label: 'Gift',
						value: 2,
					},
				],
				selectList3: [{
						label: 'All State',
						value: '',
					},
					{
						label: 'Processing',
						value: 0,
					},
					{
						label: 'Successful',
						value: 1,
					},
					{
						label: 'Failed',
						value: 2,
					},
				],
			}
		},
		mounted() {
			this.open()
		},
		computed: {
			...mapState(['currentCountry']), // 映射 user 模块下的 userInfo 状态
		},
		methods: {
			// 根据不同时区转化时间
			convertUTCTime(utcTimestamp){
				// 获取用户本地时区偏移量（分钟）
				const utcMoment = moment.utc(utcTimestamp);
				const localMoment = utcMoment.tz(this.currentCountry.timezone);
				const formattedTime = localMoment.format('YYYY-MM-DD HH:mm:ss');
				return formattedTime
			},
			close() {
				this.$emit('close', false)
			},
			clickClose() {
				if (this.rdType == 1) {
					this.close()
				} else if (this.rdType != 1) {
					this.rdType = 1
				}
			},
			open() {
				this.rdType = 1
				if(localStorage.getItem('token')){
					this.getTransactions()
				}
			},
			// 获取交易记录
			getTransactions() {
				this.$api.getTransactions({
					...this.params,
					day: this.select1,
					type: this.select2,
					status: this.select3,
				}).then(res => {
					this.total = res.total
					this.transactionsList = res.rows
				})
			},
			// 切换页面
			changePageNum(e) {
				this.params.pageNum = e
				this.getTransactions()
			},
			// 监听筛选分类项
			changeSelect(e, type) {
				this.params.pageNum = 1
				if (type == 1) {
					this.select1 = e
				} else if (type == 2) {
					this.select2 = e
				} else if (type == 2) {
					this.select3 = e
				}
				this.getTransactions()
			},

		},
	}
</script>

<style lang="scss">
	.trade_dialog_menu {
		.el-input__inner {
			background: #303643 !important;
			font-size: 14px;
			color: #B0C3E3;
		}


	}

	.el-popper {
		background: #303643 !important;
		color: #B0C3E3 !important;
	}

	.bet_search_time_box {
		.el-range-input {
			background: rgba(0, 0, 0, 0);
			color: #FFFFFF !important;
			font-size: 14px;
		}

		.el-picker-panel__content {
			background: #303643;
		}
	}
</style>
<style scoped lang="scss">
	.trade_dialog_box {
		position: absolute;
		left: 0;
		top: 0;
		width: 494px;
		min-width: 494px;
		min-height: 661px;
		max-height: 800px;
		background: #15161C;
		border-radius: 18px;
		max-height: 700px;
		overflow-y: auto;
		-ms-overflow-style: none;
		scrollbar-width: none;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		padding-bottom: 20px;
	}

	.bet_avatar_menu {
		position: relative;
		width: 205px;
		background: #15161C !important;
		border: none !important;
	}

	.bet_avatar_menu_item {
		display: flex;
		align-items: center;
		height: 36px;
		font-size: 16px;
		font-weight: 500;
		color: #A2B4D1 !important;
	}

	.trade_dialog_top_box {
		width: 494px;
		height: 110px;
		background: #161A22;
		border-radius: 18px 18px 0 0;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.trade_dialog_top {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 70px;
		color: #F0F0F0;
		font-size: 22px;
	}

	.trade_dialog_top_title {
		color: #F0F0F0;
		font-size: 24px;
	}

	.trade_dialog_top_close_icon {
		width: 43.38px;
		height: 28.92px;
		cursor: pointer;
	}


	.trade_dialog_content {
		flex: 1;
		width: 100%;
		box-sizing: border-box;
		padding: 21px 18px 20px;
		text-align: left;
		overflow-y: auto;
	}

	.trade_dialog_day_box {
		width: 97px;
		height: 40px;
		background: #7F8284;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 5px;
		font-weight: bold;
		font-size: 12px;
		color: #161616;
		margin-left: 20px;
		cursor: pointer;

	}

	.trade_dialog_list {
		width: 100%;
	}

	.trade_dialog_list_item {
		width: 100%;
		height: 84.04px;
		box-sizing: border-box;
		padding: 0 13px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #1F242F;
		border-radius: 8px;
		margin-bottom: 12px;
	}

	.trade_dialog_list_item_avatar {
		width: 40px;
		height: 40px;
		border-radius: 3px;
	}
	
	.trade_dialog_list_item_info {
		flex: 1;
		margin-left: 9px;
		color: #fff;
		font-weight: 500;
	}

	.trade_dialog_list_item_name {
		font-weight: 500;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 18px;
	}

	.trade_dialog_list_item_time {
		font-weight: 500;
		font-size: 14px;
		color: #7A8BA8;
		line-height: 18px;
		margin-top: 8px;
	}

	.trade_dialog_list_item_right {
		display: flex;
		flex-direction: column;
		align-items: end;
		margin-left: 20px;
	}

	.trade_dialog_list_item_right_title {
		font-weight: 600;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 22px;
	}

	.trade_dialog_list_item_right_tag {
		min-width: 47px;
		height: 19px;
		background: rgba(20, 235, 116, 0.2);
		border-radius: 98px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 500;
		font-size: 13px;
		color: #14EB74;
		margin-top: 9px;
		box-sizing: border-box;
		padding: 0 8px;
	}

	.trade_tag2 {
		background: rgba(255, 82, 82, 0.2) !important;
		color: #FF5252;
	}

	.trade_tag3 {
		background: rgba(255, 234, 74, 0.2) !important;
		color: #FFEA4A;
	}

	.bet_search_time_box {
		width: 223.51px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.bet_search_time {
		width: 223.51px;
		background: #303643;
		cursor: pointer;
	}


	.trade_dialog_menu {}

	.trade_dialog_list_bet_no {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 100px;
	}

	.trade_dialog_list_bet_no_icon {
		width: 344px;
		height: 280.09px;
	}
	.flex_as_c {
		padding-top: 18px;
	}
</style>